import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { EmptyState } from 'components/empty_state';
import { useNewEmptyStates, CONTENT_PAGES } from 'features/empty_state';
import { useTemplateTiles, getTemplatesForTiles } from 'services/workflows/templates';
import { appWorkflowTemplatesListUrl } from 'services/workflows/url';
import { TemplatesList } from '../../../templates_list';
import { WorkflowTabs } from '../workflow_tabs';
import { Header } from './header';
const bodyIsPhoneCss = "b1rqk0za";
const bodyCss = "b2lczhd";
const Body = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(bodyCss, {
    [bodyIsPhoneCss]: isPhone
  }, props.className)} />;
});
const footerIsTabletUpCss = "f1lpl5sn";
const footerCss = "f1m9oa8x";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(footerCss, {
    [footerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const tabContainerCss = "t10zwg7o";
const TabContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tabContainerCss, props.className)} />;
});
export const SplashScreen = ({
  owner
}) => {
  const templates = useTemplateTiles();
  const isNewEmptyStateEnabled = useNewEmptyStates();
  if (isNewEmptyStateEnabled) {
    return <div>
        <Body>
          <EmptyState type="templates" contentKey={CONTENT_PAGES.workflows}>
            <TemplatesList owner={owner} templateIds={getTemplatesForTiles()} isEmptyState />
          </EmptyState>
        </Body>
        <Footer>
          <Button as="a" decoration="secondary-outline" href={appWorkflowTemplatesListUrl(owner)}>
            {I18n.t('publisher.title.show_more_alternate')}
          </Button>
        </Footer>
      </div>;
  }
  return <div>
      <TabContainer>
        {owner.type === 'user' && <WorkflowTabs />}
      </TabContainer>
      <Header owner={owner} />
      <Body>
        <TemplatesList owner={owner} templateIds={templates} />
      </Body>
      <Footer>
        <Button as="a" decoration="secondary-outline" href={appWorkflowTemplatesListUrl(owner)}>
          {I18n.t('publisher.title.show_more')}
        </Button>
      </Footer>
    </div>;
};

require("./splash_screen.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./splash_screen.js");